import { gql } from '@apollo/client';

export default gql`
  query GetMediaStatsByCourse($courseId: String!) {
    mediaStats(courseId: $courseId)
      @rest(
        type: "MediaItemByCoursePayload"
        path: "courses/{args.courseId}/media/stats"
      ) {
      totalViews
      avgProgressPercentage
      maxProgressPercentage
      mediaItems {
        _id
        name
        thumbUrl
        totalViews
        duration
        avgProgressPercentage
        maxProgressPercentage
        studentsCount
        avgViewsPerStudent
        subject {
          _id
          name
        }
      }
    }
  }
`;
